import { FaberApi, OrbitApi } from 'api'
import { AxiosPromise } from 'axios'
import { EditUserPlanDetailsResponse, GetAllGlobalUsers } from 'types/api/faber/globalCustomers.type'

class UsaAPI {
  static getAllGlobalUsers(body: {
    searchCriteria: string
    searchValue: string
    faberToken: string
  }): AxiosPromise<GetAllGlobalUsers> {
    let searchField = ''
    switch (body.searchCriteria) {
      case 'Email':
        searchField = 'email'
        break
      case 'User ID':
        searchField = 'userid'
        break
      case 'Name':
        searchField = 'name'
        break
      case 'ICCID':
        searchField = 'iccid'
        break
      case 'Mobile Number':
        searchField = 'msisdn'
        break
    }

    const headers = {
      Authorization: `Bearer ${body.faberToken}`
    }

    if (body.searchCriteria === 'Mobile Number') {
      return FaberApi.httpGet(
        `sim/ops/account/user?search=${searchField}&value=${encodeURIComponent(body.searchValue.toLowerCase())}`,
        headers
      )
    }

    return OrbitApi.httpGet(
      `faber/user/auth0users?search=${searchField}&value=${body.searchValue.toLowerCase()}`,
      headers
    )
  }

  static editUserDetails(body: {
    userId: string
    detailCategory: string
    newValue: string
    faberToken: string
  }): AxiosPromise<EditUserPlanDetailsResponse> {
    return FaberApi.httpPost(
      `sim/ops/account/user/${body.userId}/metadata`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      { [body.detailCategory]: body.newValue }
    )
  }
}
export default UsaAPI
